<ion-grid *ngIf="csaladiNezet">
  Hozzáférés megtagadva
</ion-grid>



<ion-grid *ngIf="!csaladiNezet">
  <ion-row>
    <ion-col>
      <ion-select aria-label="Menü" interface="popover" placeholder="" label="Menü" (ionChange)="fotipusvalt($event)"
        label-placement="stacked" fill="outline" disabled
        value="1"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
        <ion-select-option value="1">Értékesítés</ion-select-option>
      </ion-select>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-select aria-label="Terminál" interface="popover" placeholder="" label="Terminál"
        [(ngModel)]="selectedterminal" label-placement="stacked" fill="outline"
        value="1"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
        <ion-select-option *ngFor="let t of terminals" [value]="t">{{t.name}}</ion-select-option>
      </ion-select>
    </ion-col>
  </ion-row>
  <div *ngIf="selectedterminal">
    <ion-row>
      <ion-col>
        <ion-chip>
          <ion-avatar>
            <img src="assets/icon/icons8-online-96.png" />
          </ion-avatar>
          <ion-label>Terminál online</ion-label>
        </ion-chip>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col style="text-align: center;">
        <span style="font-weight: bold; font-size: 30px;">{{pososszeg ? pososszeg:0 | number:'1.0-2'}} Ft</span>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button (click)="addNum(1)" color="primary" expand="block" fill="outline">1</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(2)" color="primary" expand="block" fill="outline">2</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(3)" color="primary" expand="block" fill="outline">3</ion-button>
      </ion-col>
    </ion-row><ion-row>
      <ion-col>
        <ion-button (click)="addNum(4)" color="primary" expand="block" fill="outline">4</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(5)" color="primary" expand="block" fill="outline">5</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(6)" color="primary" expand="block" fill="outline">6</ion-button>
      </ion-col>
    </ion-row><ion-row>
      <ion-col>
        <ion-button (click)="addNum(7)" color="primary" expand="block" fill="outline">7</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(8)" color="primary" expand="block" fill="outline">8</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(9)" color="primary" expand="block" fill="outline">9</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button (click)="addNum(-1)" color="primary" expand="block" fill="outline">00</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(0)" color="primary" expand="block" fill="outline">0</ion-button>
      </ion-col>
      <ion-col>
        <ion-button (click)="addNum(-2)" color="danger" expand="block" fill="outline">DEL</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button (click)="send()" color="success" expand="block">Küldés</ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-grid>



<ion-modal class="" style="z-index: 1000" #posmodal trigger="pos">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="end">
          <ion-button style="background: white; border-radius: 5px" (click)="cancel()" [strong]="true" shape="round"
            color="danger">Törlés</ion-button>
        </ion-buttons>
        <ion-title>Értékesítés</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <div style="text-align: center;">
        <ion-spinner *ngIf="fizetesstatus==0" name="crescent" color="primary"
          style="width: 150px;height: 150px;"></ion-spinner>
        <ion-icon *ngIf="fizetesstatus==1" color="success" name="checkmark-done-circle-outline"
          style="width: 150px;height: 150px;"></ion-icon>
        <ion-icon *ngIf="fizetesstatus==2" color="danger" name="close-circle-outline"
          style="width: 150px;height: 150px;"></ion-icon>
        <br>
        {{uzenet}}

        <div *ngIf="fizetesstatus==1">
          <form [formGroup]="ertekesitform">
            <ion-row>
              <ion-col>
                <ion-input label="Telefonszám / E-mail cím" label-placement="stacked" fill="outline" formControlName="azonositas"
                  placeholder=""><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input label="Név" label-placement="stacked" fill="outline" placeholder="" formControlName="nev"><ion-icon slot="start" 
                    name="time" aria-hidden="true"></ion-icon></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-button (click)="savePayment()" [disabled]="!ertekesitform.valid" color="primary"
                  expand="block">Mentés</ion-button>
              </ion-col>
            </ion-row>
          </form>
        </div>

      </div>
      <div *ngIf="fizetesstatus==2">
        <ion-row>
          <ion-col>
            <ion-button (click)="cancel()" color="primary" expand="block">Bezár</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>